export default __webpack_public_path__ + "img/800x800.6d32acf4.jpg";